<div class="custom-event-item">

  <div class="event-color"></div>

  <div class="event-main">

    <div class="event-title">
      {{ event.original.title }}
    </div>

    <div class="event-badges">

      @for (error of event.original.errors; track error) {
        <c-badge
          color="danger"
          >
          {{ getErrorLabel(error.code) }}
        </c-badge>
      }

    </div>


  </div>

  <div class="event-time">
    <div>{{ event.original.start | date:'HH:mm' }}</div>
    <div>{{ event.original.end | date:'HH:mm' }}</div>
  </div>

</div>
